import { Injectable } from "@angular/core";
import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { validators, ValidationPatterns } from "@packages/shared-business";

/**
 * Angular Validator Wrapper Service
 * Wraps framework-agnostic validators for use with Angular Reactive Forms
 */
@Injectable({
  providedIn: "root",
})
export class CustomValidatorsService {
  constructor() {}

  /**
   * Special character validator (< >)
   * Legacy method - kept for backward compatibility
   */
  specialCharValidator(control: AbstractControl): ValidationErrors | null {
    const result = validators.noSpecialChars(control.value);
    return result.valid ? null : { [result.errorKey!]: true };
  }

  /**
   * Angular ValidatorFn factories
   * Convert framework-agnostic validators to Angular ValidatorFn
   */

  static noSpecialChars(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const result = validators.noSpecialChars(control.value);
      return result.valid ? null : { [result.errorKey!]: true };
    };
  }

  static numeric(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const result = validators.numeric(control.value);
      return result.valid ? null : { [result.errorKey!]: true };
    };
  }

  static alphabetic(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const result = validators.alphabetic(control.value);
      return result.valid ? null : { [result.errorKey!]: true };
    };
  }

  static alphanumeric(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const result = validators.alphanumeric(control.value);
      return result.valid ? null : { [result.errorKey!]: true };
    };
  }

  static decimal(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const result = validators.decimal(control.value);
      return result.valid ? null : { [result.errorKey!]: true };
    };
  }

  static username(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const result = validators.username(control.value);
      return result.valid ? null : { [result.errorKey!]: true };
    };
  }

  /**
   * Direct access to validation patterns
   */
  static readonly patterns = ValidationPatterns;
}
